<template>
    <div class="settings includes-header">

        <header class="page-header settings-header">
            <router-link :to="{ name: 'root' }" class="back tag button-timid left" v-if="!inModal">x Sluiten</router-link>
            <template v-if="viewingGroup">
                <h1>Klas {{ viewingGroup.name }}</h1>
                <p>Instellingen van de klas</p>
            </template>
            <template v-else>
                <h1>Nieuwe klas</h1>
                <p>Maak een nieuwe klas voor {{ school.name }}</p>
            </template>
        </header>

        <div class="settings-links tag">
            <a href="#" :class="{ 'is-active': isGeneralActive }" @click.prevent="viewGeneral">Algemeen</a> |
            <a href="#" :class="{ 'is-active': isPlanningActive, 'is-disabled': isCreating && !isCreated }" @click.prevent="viewPlanning">Planning</a> |
            <a href="#" :class="{ 'is-active': isAssignmentsActive, 'is-disabled': isCreating && !isCreated }" @click.prevent="viewAssignments">Opdrachten</a> |
            <a href="#" :class="{ 'is-active': isInviteActive, 'is-disabled': isCreating && !isCreated }" @click.prevent="viewInvite">Leerlingen</a>
        </div>

        <component :is="view"
            class="settings-modal-content"
            :group="viewingGroup"
            :school="school"
            :isDemo="isDemo"
            :isAdmin="isAdmin"
            :isCreating="isCreating"
            :isCreated="isCreated"
            @done="done"
            @changed="dirtyModal(true)"
            @saved="savedStep"
            ref="step"></component>

    </div>
</template>


<script>
import General from 'js/components/groups/settings/General.vue'
import Planning from 'js/components/groups/settings/Planning.vue'
import Assignments from 'js/components/groups/settings/Assignments.vue'
import Invite from 'js/components/groups/settings/Invite.vue'

import { isAdmin, isDemo } from 'js/api/auth'
import track from 'js/helpers/analytics'

export default {
    name: 'GroupSettings',
    props: {
        inModal: {
            type: Boolean,
            default: false,
        },
        group: {},
        landingPage: {},
    },
    components: { General, Planning, Assignments, Invite },

    data: function() {
        return {
            view: 'General',
            createdGroupId: null,
        }
    },

    vuex: {
        getters: {
            currentUser: state => state.users.current,
            isDirty: state => state.modal.isDirty,
        },
        actions: {
            dirtyModal: ({dispatch, state}, dirty) => {
                if ( state.modal.isDirty !== dirty ) {
                    dispatch( dirty ? 'MODAL_DIRTY' : 'MODAL_CLEAN')
                }
            }
        }
    },

    computed: {
        isAdmin: function() {
            return isAdmin(this.currentUser)
        },

        isDemo: function() {
            return isDemo(this.currentUser)
        },

        isGeneralActive: function() {
            return this.view === 'General'
        },

        isPlanningActive: function() {
            return this.view === 'Planning'
        },

        isAssignmentsActive: function() {
            return this.view === 'Assignments'
        },

        isInviteActive: function() {
            return this.view === 'Invite'
        },

        isCreating: function() {
            return this.group == null
        },

        isCreated: function() {
            return this.createdGroupId != null
        },

        viewingGroup: function() {
            return this.group || this.$store.state.groups.storage[ this.createdGroupId ]
        },

        school: function() {
            const id = this.$store.state.users.current.schools[0]
            return this.$store.state.schools.storage[id]
        },

    },

    methods: {
        viewGeneral: function() {
            this.confirmDirty().then( () => this.view = 'General' , () => {})
        },
        viewPlanning: function() {
            if ( this.isCreating && !this.isCreated ) {
                return
            }
            this.confirmDirty().then( () => this.view = 'Planning' , () => {})
        },
        viewAssignments: function() {
            if ( this.isCreating && !this.isCreated ) {
                return
            }
            this.confirmDirty().then( () => this.view = 'Assignments' , () => {})
        },
        viewInvite: function() {
            if ( this.isCreating && !this.isCreated ) {
                return
            }
            this.confirmDirty().then( () => this.view = 'Invite' , () => {})
        },
        goToNextStep: function() {
            if ( this.isGeneralActive ) {
                return this.viewPlanning()
            }

            if ( this.isPlanningActive ) {
                return this.viewAssignments()
            }

            if ( this.isAssignmentsActive ) {
                return this.viewInvite()
            }
        },
        confirmDirty: function() {

            if ( !this.isDirty ) {
                return Promise.resolve()
            }

            const title = 'Wijzigingen opslaan?'
            const message = 'Wil je de gemaakte wijzigingen eerst opslaan? Als je ze ongedaan maakt gaan de wijzigingen verloren.'

            return new Promise( (resolve, reject) => {

                this.$alert({ title, message }, [
                    { name: 'Annuleren', action: reject },
                    { name: 'Ongedaan maken', danger: true, action: resolve },
                    { name: 'Opslaan', primary: true, action: () => this.$refs.step.save().then( resolve, reject ) }
                ])

            }).then( () => this.dirtyModal(false) )

        },

        savedStep: function(group) {
            this.dirtyModal(false)

            if ( group ) {
                this.createdGroupId = group.id
            }

            if ( this.isCreating ) {
                this.goToNextStep()
            }
        },

        done: function() {
            this.$emit('close')
        }

    },

    created: function() {
        if ( this.isCreating ) {
            track.event('group', 'create')
        } else {
            track.event('group', 'settings', this.group.id)
        }

        if ( this.landingPage != null ) {
            this.view = this.landingPage
        }
    }
}
</script>


<style lang="scss">

    @import 'global';
    @import 'settings';

</style>



// WEBPACK FOOTER //
// Settings.vue?01798935